import { trackFormBySubmit as trackFormBySubmit_AutoTracking } from '../track-by-submit/auto-tracking';
import { trackFormBySubmit as trackFormBySubmit_UploadTracking } from '../track-by-submit/upload-tracking';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';

type Params = {
    (formConfig: FormConfig, formValues: FormValues): void;
};

/**
 * Avaiable tracking:
 * trackFormBySubmit_AutoWorkshopTracking: Track you're covered, Track reason, workshop selection
 * trackFormBySubmit_UploadTracking: Track user selections for upload documentaion
 *
 * parkeringsskade-privat, afbestil-rejse-privat, rejseskade-privat, personskade-privat has
 * experimental tracking to measure the user selection by upload documentation
 *
 */

export const formsWithTrackBySubmit: Record<string, Params> = {
    'parkeringsskade-privat': trackFormBySubmit_AutoTracking,
    'ramt-en-person-privat': trackFormBySubmit_AutoTracking,
    'trafikale-skader-andet-privat': trackFormBySubmit_AutoTracking,
    'haervaerk-koeretoej-privat': trackFormBySubmit_AutoTracking,
    'ramt-et-dyr-privat': trackFormBySubmit_AutoTracking,
    'paakoert-bagfra-privat': trackFormBySubmit_AutoTracking,
    'ramt-en-genstand-privat': trackFormBySubmit_AutoTracking,
    'ramt-et-koeretoej-privat': trackFormBySubmit_AutoTracking,
    'parkeringsskade-erhverv': trackFormBySubmit_AutoTracking,
    'paakoert-bagfra-erhverv': trackFormBySubmit_AutoTracking,
    'ramt-et-dyr-erhverv': trackFormBySubmit_AutoTracking,
    'ramt-en-genstand-erhverv': trackFormBySubmit_AutoTracking,
    'ramt-en-person-erhverv': trackFormBySubmit_AutoTracking,
    'afbestil-rejse-privat': trackFormBySubmit_UploadTracking, // Experimental
    'rejseskade-privat': trackFormBySubmit_UploadTracking, // Experimental
    'personskade-privat': trackFormBySubmit_UploadTracking // Experimental
};
